export default function AdminAnnouncements(){return <div className='p-8'>Admin Announcements</div>}